import { render, staticRenderFns } from "./SortImages.vue?vue&type=template&id=2dcebc68&scoped=true&"
import script from "./SortImages.vue?vue&type=script&lang=js&"
export * from "./SortImages.vue?vue&type=script&lang=js&"
import style0 from "./SortImages.vue?vue&type=style&index=0&id=2dcebc68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcebc68",
  null
  
)

export default component.exports